<template>
  <div>
    <el-form
      v-loading="uploading"
      ref="form"
      :rules="rules"
      :model="form"
      label-width="150px"
    >
      <el-form-item label="比赛名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入比赛完整名称"
        >
          <copy-text slot="append" :value="form.name" icon-only></copy-text>
        </el-input>
      </el-form-item>
      <el-form-item label="比赛时间" prop="time">
        <el-date-picker
          v-model="form.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-link
          type="primary"
          underline
          @click="showFuzzyTime = true"
          class="text-btn"
          >没有确切的比赛时间？</el-link
        >
      </el-form-item>
      <el-form-item
        v-if="showFuzzyTime || this.form.fuzzyTime"
        label="模糊比赛时间"
        prop="name"
      >
        <el-input
          v-model="form.fuzzyTime"
          placeholder="请输入比赛的大致时间，若不确定请填写’待定‘"
        ></el-input>
      </el-form-item>
      <el-form-item label="比赛地点" prop="address">
        <el-input
          v-model="form.address"
          placeholder="请输入比赛地点"
        ></el-input>
      </el-form-item>
      <el-form-item label="赛事类型">
        <el-select v-model="form.eventType" placeholder="请选择赛事类型">
          <el-option label="健美比赛" :value="1"></el-option>
          <el-option label="体能赛" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="比赛规则" prop="ruleType">
        <el-select v-model="form.ruleType" placeholder="请选择比赛规则类型">
          <el-option
            v-for="item in RULE_TYPE"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="竞赛规则文章">
        <el-select
          v-model="form.ruleArticleId"
          placeholder="请输入文章标题搜索"
          filterable
          remote
          clearable
          :remote-method="searchRuleArticles"
          :loading="ruleArticleLoading"
        >
          <el-option
            v-for="item in ruleArticleList"
            :key="item._id"
            :label="item.title"
            :value="item._id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报到时间" prop="checkInTime">
        <el-input
          v-model="form.checkInTime"
          placeholder="请输入报到时间"
        ></el-input>
      </el-form-item>
      <el-form-item label="油彩喷涂时间" prop="paintTime">
        <el-input
          v-model="form.paintTime"
          placeholder="请输入油彩喷涂时间"
        ></el-input>
      </el-form-item>
      <el-form-item label="实际比赛开始时间" prop="eventStartTime">
        <el-date-picker v-model="form.eventStartTime" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="实际比赛结束时间" prop="eventEndTime">
        <el-date-picker v-model="form.eventEndTime" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="主办单位" prop="hosting">
        <el-input
          v-model="form.hosting"
          placeholder="请输入主办单位"
        ></el-input>
      </el-form-item>
      <el-form-item label="指导单位" prop="guiding">
        <el-input
          v-model="form.guiding"
          placeholder="请输入指导单位"
        ></el-input>
      </el-form-item>
      <el-form-item label="承办单位" prop="undertaking">
        <el-input
          v-model="form.undertaking"
          placeholder="请输入承办单位"
        ></el-input>
      </el-form-item>
      <el-form-item label="协办单位" prop="coOrganizing">
        <el-input
          v-model="form.coOrganizing"
          placeholder="请输入协办单位"
        ></el-input>
      </el-form-item>
      <el-form-item label="比赛项目" prop="events">
        <el-checkbox-group v-model="form.events">
          <el-checkbox
            v-for="item in EVENTS_CONFIG"
            :key="item.value"
            :label="item.name"
          ></el-checkbox>
        </el-checkbox-group>
        <el-button
          icon="el-icon-circle-plus-outline"
          size="small"
          @click="addEvent"
          >添加比赛项目</el-button
        >
      </el-form-item>
      <el-form-item v-if="type === 'edit'" label="现有比赛项目">
        <el-tag
          v-for="tag in form.events"
          :key="tag"
          @close="handleClose(tag)"
          class="event-tag"
          closable
        >
          {{ tag }}
        </el-tag>
      </el-form-item>
      <el-form-item label="编辑增加的项目">
        <span>{{ addedEvents }}</span>
      </el-form-item>
      <el-form-item label="比赛组别" prop="groups">
        <el-checkbox-group v-model="form.groups">
          <el-checkbox
            v-for="item in GROUPS_CONFIG"
            :key="item.value"
            :label="item.name"
          ></el-checkbox>
        </el-checkbox-group>
        <el-button
          icon="el-icon-circle-plus-outline"
          size="small"
          @click="addGroup"
          >添加比赛组别</el-button
        >
      </el-form-item>
      <el-form-item label="编辑增加的组别">
        <span>{{ addedGroups }}</span>
      </el-form-item>
      <el-form-item v-if="type === 'edit'" label="现有组别">
        <el-tag
          v-for="tag in form.groups"
          :key="tag"
          @close="handleGroupClose(tag)"
          class="event-tag"
          closable
        >
          {{ tag }}
        </el-tag>
      </el-form-item>
      <el-form-item label="比赛大区" prop="bigRegion">
        <el-radio-group v-model="form.bigRegion">
          <el-radio
            v-for="item in REGION_TYPE_ONE"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="比赛地理单元" prop="normalRegion">
        <el-radio-group v-model="form.normalRegion">
          <el-radio
            v-for="item in REGION_TYPE_TWO"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="赛事规模">
        <el-select v-model="form.rank" placeholder="请选择比赛规模">
          <el-option
            v-for="item in RANK_CONFIG"
            :key="item.level"
            :label="item.level"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标签">
        <el-input
          v-model="form.tagStr"
          placeholder="请输入赛事标签，以逗号分隔"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否设有新秀组">
        <el-switch
          v-model="form.hasYoung"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否设有大学生组">
        <el-switch
          v-model="form.hasStudent"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否设有少年组">
        <el-switch
          v-model="form.hasChild"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否设有免费组别">
        <el-switch
          v-model="form.hasFreeItem"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="报名条件">
        <el-input
          type="textarea"
          autosize
          placeholder="请输入报名限制条件"
          v-model="form.limit"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="IFBB PRO职业卡数量">
        <el-input v-model.number="form.hasCard"></el-input>
      </el-form-item>
      <el-form-item label="报名费用">
        <el-input v-model.number="form.cost" class="money-input"></el-input
        >元（人民币）
      </el-form-item>
      <el-form-item label="兼项费用">
        <el-input
          v-model.number="form.simultaneousCost"
          class="money-input"
        ></el-input
        >元（人民币）
      </el-form-item>
      <el-form-item label="费用说明">
        <el-input
          type="textarea"
          autosize
          placeholder="请输入备注内容"
          v-model="form.costExplanation"
        />
      </el-form-item>
      <el-form-item label="是否允许自备油彩">
        <el-switch
          v-model="form.paintFree"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
        <span class="left-margin-text">当前值为：{{ form.paintFree }}</span>
        <el-button
          class="left-margin-btn"
          size="small"
          @click="clearPaintFree"
          >重置为默认</el-button
        >
      </el-form-item>
      <el-form-item label="官方油彩费用">
        <el-input
          v-model="form.paintPrice"
          type="textarea"
          autosize
        ></el-input
        >
      </el-form-item>
      <el-form-item label="奖励设置">
        <el-input
          type="textarea"
          autosize
          placeholder="请输入奖励设置"
          v-model="form.awards"
        />
      </el-form-item>
      <el-form-item label="奖金总额">
        <el-input
          autosize
          placeholder="请输入奖励设置"
          v-model.number="form.awardsTotal"
        />
      </el-form-item>
      <el-form-item label="报名方式">
        <template>
          <div class="register-item">
            <span class="label">报名方式类型</span>
            <el-select
              v-model="form.register.type"
              placeholder="请选择报名方式类型"
            >
              <el-option
                v-for="item in REGISTER_TYPE"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="register-item">
            <span class="label">报名截止时间</span>
            <el-date-picker
              v-model="form.register.deadline"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              default-time="23:59:00"
              placeholder="请选择报名截止时间"
            >
            </el-date-picker>
          </div>
          <div class="register-item">
            <span class="label"
              >报名方式（报名链接/报名二维码链接/微信号/手机号/邮箱等）</span
            >
            <el-upload
              v-if="formObj.register.type === 1"
              action=""
              :http-request="onUploadQRcode"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :limit="1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-input
              v-model="form.register.url"
              placeholder="请根据选择的报名类型填写报名信息"
            ></el-input>
          </div>
        </template>
      </el-form-item>
      <el-form-item label="联系人" class="contact-wrapper">
        <template>
          <div
            v-for="(item, index) in form.contact"
            :key="index"
            class="contact-item"
          >
            <span class="label">联系人姓名</span>
            <el-input v-model="item.name" style="width: 150px"></el-input>
            <span class="label">联系方式类型</span>
            <el-select v-model="item.type" placeholder="请选择报名方式类型">
              <el-option
                v-for="item in CONTACT_TYPE"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span class="label">联系方式</span>
            <el-input v-model="item.contact" style="width: 150px"></el-input>
          </div>
          <el-button
            icon="el-icon-circle-plus-outline"
            size="small"
            @click="addContact"
            >添加联系人</el-button
          >
          <el-button
            size="small"
            @click="clearContact"
            >清空联系人</el-button
          >
        </template>
      </el-form-item>
      <el-form-item label="比赛规程链接">
        <el-input
          v-model="form.regulationUrl"
          placeholder="请输入竞赛规程链接"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          autosize
          placeholder="请输入备注内容"
          v-model="form.remarks"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="是否延期">
        <el-switch
          v-model="form.delayTag"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="海报链接">
        <el-upload
          class="image-upload"
          action=""
          :http-request="onUploadPoster"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :limit="1"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="imgPreviewDialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
        <el-input v-model="form.poster" placeholder="请输入海报链接"></el-input>
      </el-form-item>
      <el-form-item label="是否开启报名">
        <el-switch
          v-model="form.enableRegister"
          active-color="#13ce66"
          inactive-color="#ff4949"
          disabled
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否开启难度显示">
        <el-switch
          v-model="form.enableDifficultyDisplay"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否可达级">
        <el-switch
          v-model="form.reachingLevel"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="运动员群二维码">
        <el-upload
          class="image-upload"
          action=""
          :http-request="onUploadGroupQrcode"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :limit="1"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-input v-model="form.groupQrcode" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="团队参赛提示">
        <el-input
          type="textarea"
          autosize
          placeholder="请输入团队参赛文字提示，支持换行"
          v-model="form.teamFormingTip"
        />
      </el-form-item>
      <el-form-item label="是否已删除">
        <el-switch
          v-model="form.isDelete"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="规程PDF链接">
        <el-input v-model="form.pdfUrl" placeholder="请输入规程PDF链接"></el-input>
      </el-form-item>
      <el-form-item label="最新赛事通知">
        <el-input v-model="form.notice" placeholder="请输入赛事最新通知" type="textarea" autosize></el-input>
      </el-form-item>
      <el-form-item label="是否自然赛">
        <el-switch
          v-model="form.isNuture"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="药检方式">
        <el-input v-model="form.detection" placeholder="请输入药检方式说明"></el-input>
      </el-form-item>
      <el-form-item label="是否显示WADA标志">
        <el-switch
          v-model="form.showWada"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否置顶推荐">
        <el-switch
          v-model="form.isPinnedRecommend"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item v-if="form.isPinnedRecommend" label="推荐理由">
        <el-input
          type="textarea"
          autosize
          placeholder="请输入置顶推荐理由，将展示在日历页推荐卡片中"
          v-model="form.pinnedRecommendReason"
        />
      </el-form-item>
      <el-form-item label="配置文件ID">
        <el-input v-model="form.configId" placeholder="请输入配置文件ID">
          <copy-text slot="append" :value="form.configId" icon-only></copy-text>
        </el-input>
      </el-form-item>
      <el-form-item label="是否被其他赛事设置为配置文件(configId)">
        <el-switch
          v-model="form.isConfigId"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否显示门票信息">
        <el-switch
          v-model="form.enableTicket"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <div v-if="form.enableTicket" class="ticket-block">
        <el-form-item label="选择已有门票赛事">
          <el-select
            v-model="ticketSourceEventId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="搜索已开启门票信息的赛事"
            :remote-method="searchTicketEvents"
            :loading="ticketEventLoading"
            :popper-append-to-body="true"
            popper-class="ticket-event-select-dropdown"
            class="ticket-event-select"
            @change="onTicketSourceEventChange"
            @visible-change="onTicketEventSelectVisibleChange"
          >
            <el-option
              v-for="event in ticketEventOptions"
              :key="event._id"
              :label="event.name"
              :value="event._id"
            >
              <div class="ticket-event-option">
                <div class="ticket-event-option__name">{{ event.name }}</div>
                <div class="ticket-event-option__meta">
                  <span>{{ formatEventOptionTime(event) }}</span>
                  <span>{{ event.address || '暂无地点' }}</span>
                </div>
              </div>
            </el-option>
            <el-option
              v-if="ticketEventOptions.length && (ticketEventLoadingMore || !ticketEventHasMore)"
              :key="ticketEventLoadingMore ? 'ticket-loading-more' : 'ticket-no-more'"
              disabled
              :label="ticketEventLoadingMore ? '加载更多赛事...' : '没有更多赛事了'"
              :value="ticketEventLoadingMore ? 'ticket-loading-more' : 'ticket-no-more'"
            >
              <div class="ticket-event-option-status">
                {{ ticketEventLoadingMore ? '加载更多赛事...' : '没有更多赛事了' }}
              </div>
            </el-option>
          </el-select>
          <div class="ticket-copy-tip">
            选择后会自动填入下方门票信息，可继续手动修改后提交。
          </div>
        </el-form-item>
        <el-form-item label="门票价格">
          <el-input v-model="form.ticketPrice" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="比赛城市">
          <el-input v-model="form.ticketCity" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="地址纬度">
          <el-input v-model="form.latitude" placeholder="请输入"></el-input>
          <el-link
            href="https://lbs.qq.com/getPoint/#Z"
            target="_blank"
            type="primary"
            >获取位置信息</el-link
          >
        </el-form-item>
        <el-form-item label="地址经度">
          <el-input v-model="form.longitude" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="观赛详细地址">
          <el-input
            v-model="form.addressDetail"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="门票详情">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入"
            v-model="form.ticketDesc"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="比赛详细时间">
          <el-input v-model="form.detailTime" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="观众入场时间">
          <el-input v-model="form.entranceTime" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="观众注意事项">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入"
            v-model="form.attention"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="购票链接">
          <el-input v-model="form.ticketUrl" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="购票二维码">
          <el-upload
            class="image-upload"
            action=""
            :http-request="onUploadTicketQrcode"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :limit="1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-input v-model="form.ticketQrcode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="购票电话">
          <el-input v-model="form.ticketPhone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="购票微信">
          <el-input v-model="form.ticketWechat" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="门票海报">
          <el-upload
            class="image-upload"
            action=""
            :http-request="onUploadTicketPoster"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :limit="1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-input v-model="form.tickerPoster" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="是否免费预约">
          <el-switch
            v-model="form.isFreeAppointment"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>
      </div>
      <el-form-item class="footer-btn">
        <el-button type="primary" @click="onSubmit">{{
          type === "edit" ? "保存修改" : "立即创建"
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  EVENTS_CONFIG,
  GROUPS_CONFIG,
  RANK_CONFIG,
  REGISTER_TYPE,
  CONTACT_TYPE,
  REGION_TYPE_ONE,
  REGION_TYPE_TWO,
  RULE_TYPE
} from "./constant";
import uploadMixin from "../../mixin/upload";
import {
  confirmLinkEventUsers,
  getMatchedLinkedUserIds,
  getEventIdFromResponse,
  reviewEventUserAssociations
} from "@/utils/eventUserAssociation";

export default {
  props: {
    formObj: {
      type: Object,
      default: () => ({
        name: "",
        time: "", // TODO:从数组转化为startTime和endTime
        fuzzyTime: "",
        checkInTime: "",
        paintTime: "",
        eventStartTime: "",
        eventEndTime: "",
        address: "",
        hosting: "",
        guiding: "",
        undertaking: "",
        coOrganizing: "",
        events: [],
        groups: [],
        rank: "",
        tags: [], // TODO:转化为数组
        tagStr: "",
        hasYoung: false,
        hasStudent: false,
        hasChild: false,
        hasFreeItem: false,
        ruleType: 1,
        ruleArticleId: "",
        limit: "",
        hasCard: 0,
        cost: 0,
        costExplanation: "",
        simultaneousCost: 0,
        isRecommend: false,
        isDelete: false,
        register: {
          type: 0,
          deadline: "",
          url: "",
        },
        isTop: false,
        priority: 0,
        contact: [],
        remarks: "",
        regulationUrl: "",
        awards: "",
        awardsTotal: 0,
        delayTag: false,
        poster: "",
        enableRegister: false,
        enableDifficultyDisplay: false,
        bigRegion: -1,
        normalRegion: -1,
        reachingLevel: false, // 是否可达级
        groupQrcode: "",
        enableTicket: false,
        ticketPrice: "",
        addressDetail: "",
        ticketDesc: "",
        entranceTime: "",
        attention: "",
        ticketUrl: "",
        ticketQrcode: "",
        ticketPhone: "",
        ticketWechat: "",
        tickerPoster: "",
        isFreeAppointment: false,
        detailTime: "",
        ticketCity: "",
        latitude: "",
        longitude: "",
        paintFree: "",
        paintPrice: "",
        pdfUrl: "",
        notice: "",
        isNuture: false,
        detection: "",
        showWada: false,
        isPinnedRecommend: false,
        pinnedRecommendReason: "",
        configId: "",
        isConfigId: false,
        eventType: 1,
        teamFormingTip: ""
      }),
    },
    type: {
      type: String,
      default: "add",
    },
  },
  mixins: [uploadMixin],
  watch: {
    'formObj.ruleArticleId': {
      immediate: true,
      handler(newVal) {
        if (newVal && this.ruleArticleList.length === 0) {
          this.fetchArticleById(newVal)
        }
      }
    }
  },
  data() {
    return {
      EVENTS_CONFIG,
      GROUPS_CONFIG,
      RANK_CONFIG,
      REGISTER_TYPE,
      CONTACT_TYPE,
      REGION_TYPE_ONE,
      REGION_TYPE_TWO,
      RULE_TYPE,
      showFuzzyTime: false,
      addedEvents: [],
      addedGroups: [],
      ruleArticleList: [],
      ruleArticleLoading: false,
      searchArticleTimer: null,
      ticketSourceEventId: "",
      ticketEventOptions: [],
      ticketEventLoading: false,
      ticketEventLoadingMore: false,
      ticketEventSearchKeyword: "",
      ticketEventSearchPageNum: 1,
      ticketEventSearchPageSize: 20,
      ticketEventSearchTotal: 0,
      ticketEventHasMore: false,
      ticketEventScrollWrap: null,
      ticketEventSearchSeq: 0,
      searchTicketEventTimer: null,
      rules: {
        name: [
          { required: true, message: "请输入比赛名称", trigger: "blur" },
          {
            min: 3,
            max: 200,
            message: "长度在 3 到 200 个字符",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输入比赛地点", trigger: "blur" },
          {
            min: 3,
            max: 200,
            message: "长度在 3 到 200 个字符",
            trigger: "blur",
          },
        ],
        events: [
          {
            validator: (rule, value, callback) => {
              if ((!value || value.length === 0) && this.addedEvents.length === 0) {
                callback(new Error("请至少选择或添加一个比赛项目"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        groups: [
          {
            validator: (rule, value, callback) => {
              if ((!value || value.length === 0) && this.addedGroups.length === 0) {
                callback(new Error("请至少选择或添加一个比赛组别"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      tempImgUrl: "",
      uploading: false,
      currentUpload: "", // 当前正在上传的字段
    };
  },
  beforeDestroy() {
    if (this.searchArticleTimer) {
      clearTimeout(this.searchArticleTimer)
    }
    if (this.searchTicketEventTimer) {
      clearTimeout(this.searchTicketEventTimer)
    }
    this.detachTicketEventSelectScroll()
  },
  computed: {
    form() {
      return this.formObj;
    },
  },
  methods: {
    onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          return this.$message.error("表单信息填写错误，请根据提示检查！");
        }
        if (!this.checkContact()) return;
        const previouslyMatchedUserIds = this.type === "edit"
          ? await getMatchedLinkedUserIds(this, this.form._id)
          : [];
        if (this.form.time.length === 2) {
          this.form.startTime = this.form.time[0];
          this.form.endTime = this.form.time[1];
        }
        this.form.tags = this.form.tagStr ? this.form.tagStr.split(",") : [];
        this.form.events = this.form.events.concat(this.addedEvents);
        this.form.groups = this.form.groups.concat(this.addedGroups);
        if (this.form.paintFree === '') {
          delete this.form.paintFree
        }
        if (this.form.paintPrice === '') {
          delete this.form.paintPrice
        }

        let url = "";
        if (this.type === "edit") {
          url = "/update";
        } else {
          url = "/add_event";
        }
        this.$axios
          .post(url, JSON.stringify(this.form), {
            headers: {
              "x-auth-token": localStorage.getItem("bde_token"),
            },
          })
          .then(async (res) => {
            if (res.data.code === "success") {
              this.$message.success("操作成功！");
              if (this.type !== "edit") {
                await confirmLinkEventUsers(this, {
                  eventId: getEventIdFromResponse(res),
                  eventName: this.form.name
                });
              } else {
                // 先关闭赛事编辑弹窗，避免关联确认框叠在编辑弹窗上方。
                this.$emit("edit-success");
                await new Promise(resolve => setTimeout(resolve, 300));
                await reviewEventUserAssociations(this, {
                  eventId: getEventIdFromResponse(res) || this.form._id,
                  eventName: this.form.name,
                  previouslyMatchedUserIds
                });
              }
              if (this.type !== "edit") {
                this.$emit("edit-success");
              }
              this.addedEvents = [];
              this.addedGroups = [];
              if (this.type !== "edit") {
                this.$router.push("/");
              }
            } else {
              this.$message.error("请求错误！");
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err.response.data.message);
            if (err.response.data.code === "token_timeout") {
              this.$message.error("登录过期，请重新登录！");
            }
          });
      });
    },
    addContact() {
      this.form.contact.push({
        name: "",
        type: 0,
        contact: "",
      });
    },
    checkContact() {
      let flag = true;
      this.form.contact.map((item) => {
        if (!item.name || !item.contact) {
          this.$message.error("联系人信息未填写完整！");
          return (flag = false);
        }
      });
      return flag;
    },
    addEvent() {
      this.$prompt("请输入比赛项目名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{2,50}$/,
        inputErrorMessage: "项目名称格式不正确",
      })
        .then(({ value }) => {
          this.addedEvents.push(value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    addGroup() {
      this.$prompt("请输入组别名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{2,50}$/,
        inputErrorMessage: "组别名称不正确",
      })
        .then(({ value }) => {
          this.addedGroups.push(value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    handleClose(tag) {
      this.form.events.splice(this.form.events.indexOf(tag), 1);
    },
    handleGroupClose(tag) {
      this.form.groups.splice(this.form.groups.indexOf(tag), 1);
    },
    onUploadPoster(param) {
      this.uploading = true;
      this.uploadImg(param, {
        onSuccess: (data) => {
          this.formObj.poster =
            "https://cdn.jirou.fit/" +
            data.uploadResult.ImageUri +
            "~tplv-700tmnc25s-yasuo.image";
          this.uploading = false;
          this.$message.success("图片上传成功");
        },
        onError: () => {
          this.uploading = false;
          this.$message.error("上传失败");
        }
      });
    },
    onUploadQRcode(param) {
      this.uploading = true;
      this.uploadImg(param, {
        onSuccess: (data) => {
          this.formObj.register.url =
            "https://cdn.jirou.fit/" +
            data.uploadResult.ImageUri +
            "~tplv-700tmnc25s-yasuo.image";
          this.uploading = false;
          this.$message.success("图片上传成功");
        },
        onError: () => {
          this.uploading = false;
          this.$message.error("上传失败");
        }
      });
    },
    onUploadGroupQrcode(param) {
      this.uploading = true;
      this.uploadImg(param, {
        onSuccess: (data) => {
          this.formObj.groupQrcode =
            "https://cdn.jirou.fit/" +
            data.uploadResult.ImageUri +
            "~tplv-700tmnc25s-yasuo.image";
          this.uploading = false;
          this.$message.success("图片上传成功");
        },
        onError: () => {
          this.uploading = false;
          this.$message.error("上传失败");
        }
      });
    },
    onUploadTicketQrcode(param) {
      this.uploading = true;
      this.uploadImg(param, {
        onSuccess: (data) => {
          this.formObj.ticketQrcode =
            "https://cdn.jirou.fit/" +
            data.uploadResult.ImageUri +
            "~tplv-700tmnc25s-yasuo.image";
          this.uploading = false;
          this.$message.success("图片上传成功");
        },
        onError: () => {
          this.uploading = false;
          this.$message.error("上传失败");
        }
      });
    },
    onUploadTicketPoster(param) {
      this.uploading = true;
      this.uploadImg(param, {
        onSuccess: (data) => {
          this.formObj.tickerPoster =
            "https://cdn.jirou.fit/" +
            data.uploadResult.ImageUri +
            "~tplv-700tmnc25s-yasuo.image";
          this.uploading = false;
          this.$message.success("图片上传成功");
        },
        onError: () => {
          this.uploading = false;
          this.$message.error("上传失败");
        }
      });
    },
    clearContact() {
      this.form.contact = [];
    },
    clearPaintFree() {
      this.form.paintFree = null;
    },
    formatEventOptionTime(event) {
      if (!event) return '暂无时间'
      if (event.fuzzyTime) return event.fuzzyTime
      const start = event.startTime ? this.$dayjs(event.startTime).format('YYYY-MM-DD') : ''
      const end = event.endTime ? this.$dayjs(event.endTime).format('YYYY-MM-DD') : ''
      if (start && end && start !== end) return `${start} 至 ${end}`
      return start || end || '暂无时间'
    },
    searchTicketEvents(keyword) {
      const text = (keyword || '').trim()
      if (this.searchTicketEventTimer) {
        clearTimeout(this.searchTicketEventTimer)
      }
      if (!text) {
        this.resetTicketEventSearchState()
        return
      }
      this.ticketEventSearchKeyword = text
      this.ticketEventSearchPageNum = 1
      this.ticketEventSearchTotal = 0
      this.ticketEventHasMore = false
      this.ticketEventLoading = true
      this.searchTicketEventTimer = setTimeout(() => {
        this.requestTicketEvents(text, 1, false)
      }, 350)
    },
    resetTicketEventSearchState() {
      this.ticketEventSearchSeq++
      if (this.searchTicketEventTimer) {
        clearTimeout(this.searchTicketEventTimer)
        this.searchTicketEventTimer = null
      }
      this.ticketEventOptions = []
      this.ticketEventSearchKeyword = ''
      this.ticketEventSearchPageNum = 1
      this.ticketEventSearchTotal = 0
      this.ticketEventHasMore = false
      this.ticketEventLoading = false
      this.ticketEventLoadingMore = false
      this.detachTicketEventSelectScroll()
    },
    requestTicketEvents(keyword, pageNum = 1, append = false) {
      const seq = ++this.ticketEventSearchSeq
      this.$axios
        .post('/admin_query_by_keyword', {
          pageNum,
          pageSize: this.ticketEventSearchPageSize,
          name: keyword,
          includeDeleted: false,
          enableTicket: true
        })
        .then((res) => {
          if (seq !== this.ticketEventSearchSeq) return
          const list = (res.data && res.data.res && res.data.res.list) || []
          const total = (res.data && res.data.res && res.data.res.total) || 0
          this.ticketEventOptions = append ? this.mergeTicketEventOptions(this.ticketEventOptions, list) : list
          this.ticketEventSearchPageNum = pageNum
          this.ticketEventSearchTotal = total
          this.ticketEventHasMore = this.ticketEventOptions.length < total
        })
        .catch((err) => {
          if (seq !== this.ticketEventSearchSeq) return
          if (!append) this.ticketEventOptions = []
          this.ticketEventHasMore = false
          this.$message.error((err.response && err.response.data && err.response.data.message) || '门票赛事搜索失败')
        })
        .finally(() => {
          if (seq === this.ticketEventSearchSeq) {
            this.ticketEventLoading = false
            this.ticketEventLoadingMore = false
          }
        })
    },
    mergeTicketEventOptions(current, next) {
      const exists = new Set(current.map(item => item._id))
      return current.concat(next.filter(item => !exists.has(item._id)))
    },
    loadMoreTicketEvents() {
      if (!this.ticketEventSearchKeyword || !this.ticketEventHasMore || this.ticketEventLoading || this.ticketEventLoadingMore) return
      this.ticketEventLoadingMore = true
      this.requestTicketEvents(this.ticketEventSearchKeyword, this.ticketEventSearchPageNum + 1, true)
    },
    onTicketEventSelectVisibleChange(visible) {
      if (visible) {
        this.$nextTick(this.attachTicketEventSelectScroll)
      } else {
        this.detachTicketEventSelectScroll()
      }
    },
    attachTicketEventSelectScroll() {
      this.detachTicketEventSelectScroll()
      const wrap = document.querySelector('.ticket-event-select-dropdown .el-select-dropdown__wrap')
      if (!wrap) return
      this.ticketEventScrollWrap = wrap
      wrap.addEventListener('scroll', this.handleTicketEventSelectScroll)
    },
    detachTicketEventSelectScroll() {
      if (!this.ticketEventScrollWrap) return
      this.ticketEventScrollWrap.removeEventListener('scroll', this.handleTicketEventSelectScroll)
      this.ticketEventScrollWrap = null
    },
    handleTicketEventSelectScroll(event) {
      const wrap = event.target
      const distanceToBottom = wrap.scrollHeight - wrap.scrollTop - wrap.clientHeight
      if (distanceToBottom <= 24) {
        this.loadMoreTicketEvents()
      }
    },
    onTicketSourceEventChange(eventId) {
      const event = this.ticketEventOptions.find(item => item._id === eventId)
      if (!event) return
      this.applyTicketInfoFromEvent(event)
    },
    applyTicketInfoFromEvent(event) {
      const fields = [
        'ticketPrice',
        'ticketCity',
        'latitude',
        'longitude',
        'addressDetail',
        'ticketDesc',
        'detailTime',
        'entranceTime',
        'attention',
        'ticketUrl',
        'ticketQrcode',
        'ticketPhone',
        'ticketWechat',
        'tickerPoster',
        'isFreeAppointment'
      ]
      fields.forEach((field) => {
        if (event[field] !== undefined && event[field] !== null) {
          this.$set(this.form, field, event[field])
        }
      })
      this.$message.success('已带入门票信息，可继续手动修改')
    },
    searchRuleArticles(query) {
      if (this.searchArticleTimer) {
        clearTimeout(this.searchArticleTimer)
      }
      this.searchArticleTimer = setTimeout(() => {
        if (!query) {
          this.ruleArticleList = []
          return
        }
        this.ruleArticleLoading = true
        fetch(`https://fc-mp-c49557d4-8550-416d-8dfc-4207ccec986c.next.bspapp.com/getRuleArticles?keyword=${encodeURIComponent(query)}`)
          .then(res => res.json())
          .then(data => {
            this.ruleArticleList = (data.data && data.data.list) || []
            this.ruleArticleLoading = false
          })
          .catch(err => {
            console.log('搜索文章失败', err)
            this.ruleArticleLoading = false
          })
      }, 300)
    },
    fetchArticleById(id) {
      fetch(`https://fc-mp-c49557d4-8550-416d-8dfc-4207ccec986c.next.bspapp.com/getRuleArticles?id=${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.data && data.data.list && data.data.list.length > 0) {
            this.ruleArticleList = data.data.list
          }
        })
        .catch(err => {
          console.log('获取文章详情失败', err)
        })
    }
  },
};
</script>

<style scoped>
.money-input {
  width: 100px;
  margin-right: 10px;
}

.register-item {
  min-height: 50px;
}

.register-item > .label {
  display: inline-block;
  margin-right: 10px;
}

.contact-wrapper {
  margin-top: 50px;
}

.contact-item {
  margin-bottom: 20px;
}

.contact-item > .label {
  margin: 0 10px 0 20px;
}

.contact-item > span:first-child {
  margin-left: 0;
}

.footer-btn {
  margin-top: 100px;
}

.text-btn {
  display: inline-block;
  margin-left: 20px;
}

.event-tag {
  max-width: 100%;
  margin: 5px;
  height: auto;
  white-space: normal;
  line-height: 1.5;
}

.image-upload {
  margin-bottom: 10px;
}
.ticket-block {
  padding: 20px;
  border-radius: 20px;
  border: 1px dashed #999;
}
.ticket-event-select {
  width: 100%;
}

.ticket-copy-tip {
  margin-top: 6px;
  color: var(--text-secondary, #909399);
  font-size: 12px;
  line-height: 1.5;
}

.ticket-event-option {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 42px;
  line-height: 1.35;
}

.ticket-event-option__name {
  color: var(--text-primary, #303133);
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ticket-event-option__meta {
  display: flex;
  gap: 12px;
  color: var(--text-secondary, #8492a6);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ticket-event-option-status {
  color: var(--text-secondary, #8492a6);
  font-size: 12px;
  text-align: center;
}
.left-margin-btn, .left-margin-text {
  margin-left: 10px;
}

@media (max-width: 768px) {
  .left-margin-text {
    margin-left: 12px !important;
    margin-right: 8px;
  }

  .left-margin-btn {
    margin-left: 0 !important;
    margin-top: 0;
  }

  .register-item {
    min-height: 0;
    margin-bottom: 12px;
    padding: 12px;
    border-left: 3px solid var(--brand-primary, #c04851);
    border-radius: 4px;
    background-color: var(--bg-table-header, #f5f7fa);
  }

  .register-item > .label {
    display: block;
    margin: 0 0 8px;
    font-size: 13px;
    line-height: 1.5;
    color: var(--text-secondary, #909399);
  }

  .el-checkbox-group + .el-button {
    margin-top: 10px;
  }

  .ticket-event-option__meta {
    flex-direction: column;
    gap: 2px;
    line-height: 1.3;
    white-space: normal;
  }
}
</style>

<style>
.ticket-event-select-dropdown .el-select-dropdown__item {
  height: auto;
  min-height: 50px;
  padding: 7px 12px;
  line-height: 1.35;
}

.ticket-event-select-dropdown .el-select-dropdown__wrap {
  overflow-x: hidden;
}

.ticket-event-select-dropdown .el-select-dropdown__list {
  padding: 6px 0;
}

@media (max-width: 768px) {
  .ticket-event-select-dropdown.el-select-dropdown {
    left: 12px !important;
    right: 12px !important;
    width: auto !important;
    min-width: 0 !important;
    max-width: calc(100vw - 24px);
  }

  .ticket-event-select-dropdown .el-select-dropdown__wrap {
    max-height: 52vh;
    overflow-x: hidden;
  }

  .ticket-event-select-dropdown .el-select-dropdown__list {
    padding: 6px;
  }

  .ticket-event-select-dropdown .el-select-dropdown__item {
    min-height: 58px;
    padding: 8px 10px;
    white-space: normal;
  }

  .ticket-event-select-dropdown .ticket-event-option__name {
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    word-break: break-word;
  }

  .ticket-event-select-dropdown .popper__arrow {
    display: none;
  }
}
</style>
